import moment from 'moment';
import { getCompletReseauTempoAsync } from '@/api/reseaux';
import { getProduitAssocie } from '@/api/devis';
import returnLiaisonTarif from '@/services/catalogue/getLiaisonTarifADate';
import genererLiaisonTarifFromProduitAssocie from '@/services/devisCommandes/genererLiaisonTarifFromProduitAssocie';
import genererLigneCommande from '@/services/devisCommandes/genererLigneCommande';
import miseAJourArticle from '@/services/devisCommandes/miseAJourArticle';
import { gestionLiaisonsTarifProduitsAssocies } from '@/services/devis/gestionProduitsAssocies';
import ajoutOrdre from '@/services/devisCommandes/ajoutOrdre';
import { choixEtatSouhaite } from '@/services/panier/devis';
import { CATEGORIE_REGROUPEMENT } from '@/configuration/produitConf';
import { REGROUPEMENT, AUCUN } from '@/configuration/devisConf';
import { BLOQUE as BLOQUE_DEVIS, OPTION as OPTION_DEVIS, LIGNE_CMD_SEL_TYPE_SEMAINE } from '@/configuration/optionBlocage';
import genererGuid from '@/services/general/genererGuid';
import { getDateByJourAnneeSemaine } from '@/services/general/getAnneeSemaine';
import generationToutesLignesCommandes from './genererToutesLignesCommande';

async function generationLigneCommandeRegroupement(
  produitReseau, produitsAssocies, reseau, listIdProduits, ligneOldDevis, tauxTvaDefault) {
  const ligne = genererLigneCommande();
  miseAJourArticle(ligne, tauxTvaDefault);
  ligne.title = produitsAssocies && produitsAssocies.libelle
    ? produitReseau.reference + ' - ' + produitsAssocies.libelle : produitReseau.reference;
  ligne.produitId = produitReseau.id;
  ligne.affectation = [];
  ligne.typeProduit = CATEGORIE_REGROUPEMENT;
  ligne.produit = {};
  const anneeSemaineMoment = moment(`${reseau.extensionOpportunite.annee}-${reseau.extensionOpportunite.semaine}`, 'GGGG-WW');
  ligne.dateDebut = anneeSemaineMoment.format('YYYY-MM-DD');
  ligne.dateFin = anneeSemaineMoment.add(6, 'days').format('YYYY-MM-DD');
  ligne.etatObtenu = ligneOldDevis
    ? ligneOldDevis.etatObtenu : AUCUN;
  if (reseau.extensionOpportunite.demande) {
    ligne.etatSouhaite = choixEtatSouhaite(reseau.extensionOpportunite.demande);
  }
  ligne.etatProvisoire = AUCUN;
  ligne.rangOption = null;
  ligne.messagesAvertissement = null;
  ligne.tauxTva = 0;
  const anneeSemaine = parseInt(anneeSemaineMoment.format('ggggww'), 10);
  const facesSelect = reseau.listeFaces.filter(face => face.selected).map(face => ({
    anneeSemaine: anneeSemaine,
    produitId: face.idProduit,
    reference: face.facCode,
    type: LIGNE_CMD_SEL_TYPE_SEMAINE,
  }));
  const qteFacesSouhaitees = parseInt(reseau.extensionOpportunite.facesSouhaitees, 10);
  ligne.ligneReseau = {
    anneeSemaine: anneeSemaine,
    qteFacesPrevues: reseau.extensionOpportunite.facesPrevues,
    qteFacesSouhaitees: qteFacesSouhaitees || 0,
    jourDepart: reseau.jourDepart,
    referenceVentePartielle: reseau.extensionOpportunite.referenceVentePartielle
      ? reseau.extensionOpportunite.referenceVentePartielle : genererGuid(),
    lignesCmdSelProduits: ligne.etatSouhaite === BLOQUE_DEVIS ? facesSelect : [],
  };
  ligne.lignesCmdSelOptionProduit = ligne.etatSouhaite === OPTION_DEVIS ? facesSelect : [];

  ligne.etatDeLaDemande = (ligne.etatObtenu !== ligne.etatSouhaite) ||
    (ligneOldDevis && ligneOldDevis.ligneReseau.qteFacesSouhaitees !== qteFacesSouhaitees);

  if (ligneOldDevis) {
    ligne.id = ligneOldDevis.id;
    ligne.dateEtatObtenu = ligneOldDevis.dateEtatObtenu;
    ligne.dateEtatSouhaite = ligneOldDevis.dateEtatSouhaite;
  }
  ligne.libelle = produitReseau.libelle;
  ligne.type = REGROUPEMENT;
  ligne.masqueLigne = false;
  if (reseau.tarifUnitaire) ligne.tarifUnitaire = true;
  if (produitsAssocies && produitsAssocies.produitEnfant) {
    await gestionLiaisonsTarifProduitsAssocies(
      produitsAssocies, reseau, listIdProduits, CATEGORIE_REGROUPEMENT);
    ligne.lignesCommande = generationToutesLignesCommandes(
      produitsAssocies, reseau.extensionOpportunite.typeDeRemise, tauxTvaDefault,
    );
  } else ligne.lignesCommande = [];
  return ligne;
}

export default async function ajoutLignesCommandeProduitReseauTempo(
  devisCommande, reseau, listIdProduits, ordre, ligneOldDevis, tauxTvaDefault,
) {
  const produitReseau = (await getCompletReseauTempoAsync(reseau.num, {
    libelle: reseau.libelle,
    ville: reseau.ville,
  })).data.result;
  let idProduitDefault = produitReseau.produitReseau.produitParDefautId;
  if (idProduitDefault === null) {
    idProduitDefault = listIdProduits.produit;
  }
  let liaisonTarif = [];
  const dateDebut = getDateByJourAnneeSemaine(
    reseau.jourDepart,
    reseau.extensionOpportunite.annee,
    reseau.extensionOpportunite.semaine);
  if (idProduitDefault !== null && produitReseau.liaisonsTarif.length > 0) {
    liaisonTarif = returnLiaisonTarif(produitReseau, idProduitDefault, dateDebut);
  }
  if (!liaisonTarif) {
    const produitAssocie = (await getProduitAssocie(idProduitDefault))
      .data.result;
    liaisonTarif = genererLiaisonTarifFromProduitAssocie(
      produitAssocie,
    );
  }
  const nouvelleLignesCommande = await generationLigneCommandeRegroupement(
    produitReseau, liaisonTarif, reseau, listIdProduits, ligneOldDevis, tauxTvaDefault,
  );
  ajoutOrdre(nouvelleLignesCommande, devisCommande.lignesCommande.length, ordre);
  return nouvelleLignesCommande;
}



// WEBPACK FOOTER //
// ./src/services/devis/ajoutProduit/ajoutProduitReseauTempo.js